import cn from 'classnames';
// Components
import { InputFooter } from 'ui3/InputFooter/InputFooter';
// UI
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './MobileSelectSheet.module.scss';

type MobileSelectTriggerProps = {
  name: string;
  label?: string;
  placeholder?: string;
  /** Text of the current selection, empty when nothing is selected. */
  valueText?: string;
  error?: string;
  disabled?: boolean;
  className?: string;
  onClick: () => void;
};

const MobileSelectTrigger = ({
  name,
  label,
  placeholder = 'Select',
  valueText,
  error,
  disabled,
  className,
  onClick,
}: MobileSelectTriggerProps) => (
  <div className={cn(styles.field, className)}>
    {label && (
      <label id={`${name}-label`} htmlFor={name} className={styles.label}>
        {label}
      </label>
    )}
    <button
      type="button"
      id={name}
      className={cn(styles.trigger, {
        [styles.placeholder]: !valueText,
        [styles.error]: Boolean(error),
      })}
      onClick={onClick}
      disabled={disabled}
      aria-haspopup="dialog"
      aria-labelledby={label ? `${name}-label ${name}-value` : undefined}
    >
      <span id={`${name}-value`} className={styles.triggerText}>
        {valueText || placeholder}
      </span>
      <MillionsIcon name="chevronDown" className={styles.chevron} />
    </button>
    <InputFooter error={error} tooltipId={`mobile-select-tooltip-${name}`} />
  </div>
);

export default MobileSelectTrigger;
